import type { ReactNode } from 'react';

interface LabeledFieldProps {
	label: string;
	children: ReactNode;
}

const LabeledField = ({ label, children }: LabeledFieldProps) => (
	<div className="flex flex-col gap-space-2">
		<span className="text-sm-medium text-neutral-600">{label}</span>
		{children}
	</div>
);

export { LabeledField };
